import Bar from '../../../../components/elements/Bar';
import { Pencil } from 'lucide-react';
import List from '../../../../components/elements/List';
import PropertyListWithBiblio from './List';
import { usePermission } from '../../../../hooks/usePermission';
import ApprovalItemActions from '../../../approval/components/ApprovalItemActions';

const PropertySetView = ({ data, onEdit }) => {
  const { isEditable } = usePermission();

  const prepareData = () => {
    if (!data) return [];
    return [
      { name: 'Název', value: data.title },
      { name: 'Popis', value: data.description },
    ];
  };

  return (
    <div>
      <Bar
        text="Detail"
        content={
          isEditable
            ? [
                <Pencil
                  key={1}
                  className="h-4 w-4"
                  onClick={onEdit}
                  data-testid="property-set-view-edit-btn"
                />,
              ]
            : []
        }
      />
      <ApprovalItemActions
        objectType="setpropertydefinition"
        objectId={data?.id}
        status={data?.status}
      />
      <List data={prepareData()} />
      <div className="mb-px">
        <Bar text="Přiřazené vlastnosti" />
        <PropertyListWithBiblio data={data?.property_definition_set || []} />
      </div>
    </div>
  );
};

export default PropertySetView;
